const getters = {
  /**
   * Returns the list of all the consoles
   * @param {*} state
   */
  getConsoles: state => {
    return state.consolesById.map(cId => state.consoles[cId]);
  },
};

export default getters;
